import Grid from '@material-ui/core/Grid';
import React from 'react';
import { TextField } from '@material-ui/core';
import FormSection from '../../../components/atom/FormSection';
import AutocompleteSelect from '../../../components/atom/AutocompleteSelect';
import { agentsInChainAutocomplete } from '../../../autocomplete';
import { ReadOnlyField, EditableField, InfoDisplay } from '../../../components/FormField';
import { useCapability } from '../../../hooks/useCapabilities';
import { CAPABILITIES } from '../../../capabilities/capabilities';

export default function BookingItemGenericSettings({
    values,
    setFieldValue,
    bookingCanModify,
    agents
}) {
    const { hasCapability } = useCapability();
    const canResource = hasCapability(CAPABILITIES.RE_SOURCE_BOOKING);

    const agentAutocompleteOptions = React.useMemo(() => {
        return [...(agents || []), { id: 0, name: 'Customer', email: '', companyName: '' }].map(
            e => ({
                id: e.id === null ? 0 : e.id,
                name: e.id === 0 ? `${e.name}` : `${e.name} (${e.companyName ? e.companyName : ''})`
            })
        );
    }, [agents]);

    return (
        <FormSection title="Generic settings">
            <InfoDisplay label="Reservation ID" value={values.id} />
            <InfoDisplay label="Status" value={values.status} />
            {values.booking_info?.reservationId && (
                <InfoDisplay
                    label="External Reservation ID"
                    value={values.booking_info?.reservationId}
                />
            )}
            {values.booking_info?.seats && (
                <InfoDisplay
                    label="Seats"
                    value={values.booking_info?.seats.map(seat => seat.name || '-').join(', ')}
                />
            )}
            {values.booking_info?.confirmationCode && (
                <EditableField
                    label="Booking info (confirmation code)"
                    value={values.booking_info?.confirmationCode}
                    onChange={ev => setFieldValue('booking_info.confirmationCode', ev.target.value)}
                    disabled={!bookingCanModify}
                />
            )}
            {values.booking_info?.bookingId && (
                <ReadOnlyField label="Booking ID" value={values.booking_info?.bookingId} />
            )}
            <Grid item xs={12}>
                <AutocompleteSelect
                    disabled={!canResource || !bookingCanModify}
                    disableClearable
                    initCall={agentAutocompleteOptions}
                    autocompleteCall={agentsInChainAutocomplete.search}
                    value={values.booking.agent_id === null ? 0 : values.booking.agent_id}
                    setValue={newValue => {
                        setFieldValue('booking.agent_id', newValue);
                    }}
                >
                    <TextField required label="Booked by" />
                </AutocompleteSelect>
            </Grid>
        </FormSection>
    );
}
